export default {
  init() {

    // Banenr Resize on Scroll
    if ($(window).width() > 1024) {
      $(document).on("scroll", function() {
        if($(document).scrollTop()>400) {
          $(".banner").addClass("smaller");
        } else {
          $(".banner").removeClass("smaller");
        }
      });
    }

    // JavaScript to be fired on the agency page
    $('.line-1').addClass('active');
    $('.line-1').each(function () {
        var characters = $(this).text().split("");
        var $this = $(this);
        $this.empty();
        $.each(characters, function (i, el) {
          if(el.indexOf(' ') > -1) {
            el = '<span class="spacer"></div>';
          }
          $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
        });
    });
    setTimeout(function(){
      $('.line-2').addClass('active');
      $('.line-2').each(function () {
          var characters = $(this).text().split("");
          var $this = $(this);
          $this.empty();
          $.each(characters, function (i, el) {
            if(el.indexOf(' ') > -1) {
              el = '<span class="spacer"></div>';
            }
            $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
          });
      });
    }, 500);
    setTimeout(function(){
      $('.line-3').addClass('active');
      $('.line-3').each(function () {
          var characters = $(this).text().split("");
          var $this = $(this);
          $this.empty();
          $.each(characters, function (i, el) {
            if(el.indexOf(' ') > -1) {
              el = '<span class="spacer"></div>';
            }
            $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
          });
      });
    }, 1000);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/agency.js